import {ClickDrawer} from '../../../../mode/ClickDrawer';
import {Point} from '@app/modules/svg/model/Point';
import {PointedView} from '@app/modules/svg/element/shape/pointed/PointedView';
import {PolylineView} from '@app/modules/svg/element/shape/pointed/polyline/PolylineView';
import {SVGEvent} from '@app/modules/svg/dataSource/constant/SVGEvent';
import {ElementType} from '@app/modules/svg/dataSource/constant/ElementType';

export class DrawPolyline extends ClickDrawer {
  protected createDrawableElement(position: Point): PointedView {
    return new PolylineView(this.drawTool.container, {overEvent: true, globalStyle: true}, [
      position, position
    ]);
  }

  public override start(call: boolean = true): void {
    super.start(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.POLYLINE_TOOL_ON);
    }
  }
  public override stop(call: boolean = true): void {
    super.stop(call);

    if (call) {
      this.drawTool.container.__call__(SVGEvent.POLYLINE_TOOL_OFF);
    }
  }

  public _new(): DrawPolyline {
    return new DrawPolyline(this.drawTool);
  }
  public get type(): ElementType {
    return ElementType.POLYLINE;
  }
}
